<script>
import DatePicker from "vuejs-datepicker";
import HolidayWarning from "@/components/_Shared/Warnings/Holiday";

import { mapState } from "vuex";
import { ptBR } from "vuejs-datepicker/dist/locale";

import moment from "@/utils/moment";
import holidayHelper from "@/utils/helpers/holiday";
import lockdownHelper from "@/utils/helpers/lockdown";
import paymentValidators from "@/utils/validators/payments";

export default {
  props: {
    title: {
      type: [String, Boolean],
      required: false,
      default: false
    },
    day: {
      type: [Date, String],
      required: false
    },
    enabledDates: {
      type: Array,
      required: false
    },
    fromDate: {
      type: Date,
      required: false,
      default: () =>
        moment()
          .add(4, "months")
          .toDate()
    },
    toDate: {
      type: Date,
      required: false,
      default: () =>
        moment()
          .subtract(1, "days")
          .toDate()
    },
    reschedule: {
      type: Boolean,
      required: false,
      default: false
    },
    address: {
      type: Object,
      required: false,
      default: false
    }
  },

  data() {
    return {
      ptBR,
      disabledDates: {},
      holidays: holidayHelper.daysWithDisabledPurchase(),
      lockdown: lockdownHelper.daysWithDisabledPurchase(this.address),
      inline: true
    };
  },

  computed: {
    ...mapState("user", ["user"]),

    canPayViaBoleto() {
      return paymentValidators.canPayViaBoleto("orders", this.day);
    }
  },

  methods: {
    firstDayToPayViaBoleto() {
      return paymentValidators.firstDayToPayViaBoleto();
    },

    daySelected(day) {
      this.$emit("daySelected", day);
    },

    generateDisabledDates() {
      let dates = this.pickDisabledDates();

      this.disabledDates = {
        from: this.fromDate,
        to: this.toDate,
        dates
      };
    },

    pickDisabledDates() {
      if (!this.enabledDates)
        return this.formatDates([...this.holidays, ...this.lockdown], true);

      var dates = this.pickDatesBetween(this.toDate, this.fromDate);
      var enabledDates = this.enabledDates;

      dates = this.formatDates(dates);
      enabledDates = this.formatDates(enabledDates);

      dates = dates.filter(e => {
        return enabledDates.indexOf(e) === -1;
      });

      dates = [...this.holidays, ...this.lockdown, ...dates];

      return this.formatDates(dates, true);
    },

    formatDates(dates, toDate = false) {
      return dates.map(e => {
        let year = moment().format("Y");
        let res = toDate
          ? moment(e, "MM-DD")
              .year(year)
              .toDate()
          : moment(e, "MM-DD")
              .year(year)
              .format("Y-MM-DD");

        return res < this.toDate
          ? moment(res)
              .add(1, "years")
              .toDate()
          : res;
      });
    },

    pickDatesBetween(startDate, endDate) {
      var dates = [],
        currentDate = startDate;

      while (currentDate <= endDate) {
        dates.push(currentDate);
        currentDate = moment(currentDate)
          .add(1, "days")
          .toDate();
      }

      return dates;
    }
  },

  mounted() {
    this.generateDisabledDates();
    this.inline = false;
  },

  components: {
    DatePicker,
    HolidayWarning
  }
};
</script>

<template>
  <div class="section mb-0">
    <div v-if="title" class="section-title">
      {{title}}
      <hr />
    </div>
    
    <date-picker
      :value="day"
      :disabledDates="disabledDates"
      :full-month-name="true"
      :maximumView="'day'"
      :language="ptBR"
      :format="'dd MMMM yyyy'"
      :inline="inline"
      calendar-class="calendar-position"
      input-class="calendar-input"
      placeholder="selecione um dia"
      @selected="daySelected"
    />

    <small v-if="day && !canPayViaBoleto">
      O dia selecionado permite pagamentos apenas pelo
      <b>cartão de crédito</b>
      , escolha à partir do dia
      <b>{{firstDayToPayViaBoleto()}}</b> caso queira efetuar o pagamento por
      <b>boleto</b>.
    </small>

    <holiday-warning v-if="day" :day="day" style="max-width: 450px; text-align: center;" />
  </div>
</template>

<style>
small {
  max-width: 450px;
  color: var(--pink);
  text-align: center;
  margin-bottom: 10px;
}

.calendar-position {
  margin-top: 10px;
}

.calendar-input {
  height: 41px !important;
}

.vdp-datepicker__calendar {
  position: relative !important;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/DatePicker.vue